module.exports = __webpack_public_path__ + "img/logo-g.060d789b.png";